import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Avatar } from '../ui/Avatar';
import { Card } from '../ui/Card';
import { Confetti } from './Confetti';
import { playRankingChangeSound } from '../../utils/sounds';
import { Trophy, TrendingUp } from 'lucide-react';
interface RankingChangeProps {
  isOpen: boolean;
  onClose: () => void;
  sellerName: string;
  sellerAvatar: string;
  newRank: number;
  overtakenName?: string;
}
export function RankingChangePopup({
  isOpen,
  onClose,
  sellerName,
  sellerAvatar,
  newRank,
  overtakenName
}: RankingChangeProps) {
  useEffect(() => {
    if (isOpen) {
      playRankingChangeSound();
      const timer = setTimeout(onClose, 5000);
      return () => clearTimeout(timer);
    }
  }, [isOpen, onClose]);
  return <AnimatePresence data-id="element-138">
      {isOpen && <div className="fixed inset-0 z-50 flex items-center justify-center pointer-events-none" data-id="element-139">
          <Confetti data-id="element-140" />

          {/* Race Car Animation */}
          <motion.div initial={{
        x: '-100vw',
        y: 100
      }} animate={{
        x: '100vw',
        transition: {
          duration: 1.5,
          ease: 'easeInOut'
        }
      }} className="fixed z-40 text-[100px] drop-shadow-2xl" style={{
        top: '40%'
      }} data-id="element-141">
            🏎️💨
          </motion.div>

          {/* Main Card */}
          <motion.div initial={{
        scale: 0,
        rotate: -10
      }} animate={{
        scale: 1,
        rotate: 0
      }} exit={{
        scale: 0,
        rotate: 10
      }} transition={{
        type: 'spring',
        bounce: 0.5
      }} className="pointer-events-auto" data-id="element-142">
            <Card className="w-[450px] bg-gradient-to-br from-slate-900 to-slate-800 border-2 border-yellow-500/50 shadow-[0_0_60px_rgba(234,179,8,0.2)] p-1 relative overflow-hidden" data-id="element-143">
              {/* Checkered Flag Pattern Background */}
              <div className="absolute inset-0 opacity-5 bg-[repeating-linear-gradient(45deg,#000_25%,transparent_25%,transparent_75%,#000_75%,#000),repeating-linear-gradient(45deg,#000_25%,transparent_25%,transparent_75%,#000_75%,#000)] bg-[length:20px_20px] bg-[position:0_0,10px_10px]" data-id="element-144" />

              <div className="bg-slate-900/90 backdrop-blur-md p-8 rounded-lg relative z-10 flex flex-col items-center text-center" data-id="element-145">
                <motion.div initial={{
              y: -50,
              opacity: 0
            }} animate={{
              y: 0,
              opacity: 1
            }} transition={{
              delay: 0.3
            }} data-id="element-146">
                  <div className="relative mb-6" data-id="element-147">
                    <Trophy className="w-16 h-16 text-yellow-500 absolute -top-10 -left-8 animate-bounce" data-id="element-148" />
                    <Avatar src={sellerAvatar} fallback={sellerName} size="xl" className="w-32 h-32 ring-4 ring-yellow-500 shadow-2xl" data-id="element-149" />
                    <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 bg-yellow-500 text-slate-900 font-black px-4 py-1 rounded-full shadow-lg whitespace-nowrap" data-id="element-150">
                      {newRank}º LUGAR
                    </div>
                  </div>

                  <h2 className="text-3xl font-black text-white italic uppercase tracking-wider mb-2" data-id="element-151">
                    Ultrapassagem!
                  </h2>

                  <div className="text-lg text-slate-300 mb-4" data-id="element-152">
                    <span className="font-bold text-white" data-id="element-153">{sellerName}</span>
                    {overtakenName ? <>
                        {' '}
                        passou{' '}
                        <span className="text-text-muted line-through decoration-red-500 decoration-2" data-id="element-154">
                          {overtakenName}
                        </span>
                      </> : ' subiu no ranking!'}
                  </div>

                  <div className="flex items-center justify-center gap-2 text-emerald-400 bg-emerald-400/10 px-4 py-2 rounded-full" data-id="element-155">
                    <TrendingUp className="w-5 h-5" data-id="element-156" />
                    <span className="font-bold" data-id="element-157">Novo Recorde de Vendas</span>
                  </div>
                </motion.div>
              </div>
            </Card>
          </motion.div>
        </div>}
    </AnimatePresence>;
}